module.exports = __webpack_public_path__ + "static/media/services_hairdrsser2.061a5a5e.jpg";